import type { PlayerAchievementStats, AchievementDef, AchievementResult, AchievementSport } from './types';
import { generalAchievements } from './general';
import { volleyballAchievements } from './volleyball';
import { footballAchievements } from './football';
import { basketballAchievements } from './basketball';
import { tennisAchievements } from './tennis';
import { badmintonAchievements } from './badminton';

export * from './types';

export const allAchievements: AchievementDef[] = [
  ...generalAchievements,
  ...volleyballAchievements,
  ...footballAchievements,
  ...basketballAchievements,
  ...tennisAchievements,
  ...badmintonAchievements,
];

export function achievementsBySport(sport: AchievementSport | 'all'): AchievementDef[] {
  if (sport === 'all') return allAchievements;
  return allAchievements.filter((a) => a.sport === sport);
}

export function evaluateAll(stats: PlayerAchievementStats): AchievementResult[] {
  return allAchievements.map((def) => ({
    key: def.key,
    unlocked: def.check(stats),
    progress: def.progress ? def.progress(stats) : null,
  }));
}
